import type { BFFArticleBodyElement } from "@src/app/types/bff";

import { mapBodyElementLayout } from "../ArticleBody";

export default function ArticleListNumbered({
  element,
}: {
  element: BFFArticleBodyElement["list_numbered"];
}) {
  return (
    <ol className="text-body-1 mb-8 ml-6">
      {element.children.map((child, index) => {
        if (child.type == "list_bulleted" || child.type == "list_numbered") {
          return mapBodyElementLayout(child);
        }
        return <li key={index}>{mapBodyElementLayout(child)}</li>;
      })}
    </ol>
  );
}
